export const config = {
    version: "v 1.7.0",
    environment: process.env.VUE_APP_ENVIRONMENT ?? "Development",
    api: process.env.VUE_APP_ENDPOINT ?? "https://promotion-stg.sansiri.net/promotion-stg",
    azureAd: {
        clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID ?? 'fbe2a2ad-4a59-432f-88f9-e47d9aadb690',
        authority: process.env.VUE_APP_AZURE_AD_AUTHORITY ?? 'https://login.microsoftonline.com/875bdd0a-688b-41d2-96b7-454d280043aa',
        scopes: [process.env.VUE_APP_AZURE_AD_SCOPES ?? "api://fbe2a2ad-4a59-432f-88f9-e47d9aadb690/read", "User.Read.All"]
    },
    instrumentationKey: process.env.VUE_APP_INSIGHTS_KEY ?? "29db856b-9fb0-4372-90ea-f85d850280bc",
    graphMeEndpoint: process.env.VUE_APP_GRAPH_MICROSOFT ?? 'https://graph.microsoft.com',
    endpointurllogin : process.env.ENDPOINT_URL_LOGIN ?? "https://stg-api.sansiri.net",
    redirectpromotion : process.env.REDIRECT_PROMOTION ?? "https://sourcesafe.sansiri.com/EMS"
}
